export default __webpack_public_path__ + "static/media/logochequer.01f2a143.png";